import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children, requireAdmin = false, requireApproved = false, disallowAdmin = false }) => {
  const { user, loading, isAdmin, isApproved } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-gold-500 text-xl">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && !isAdmin()) {
    return <Navigate to="/" replace />;
  }

  if (disallowAdmin && isAdmin()) {
    return <Navigate to="/admin" replace />;
  }

  if (requireApproved && !isApproved() && !isAdmin()) {
    return (
      <div className="container mx-auto px-4 py-16 text-center">
        <h1 className="text-3xl font-bold text-gold-500 mb-4">Account Pending Approval</h1>
        <p className="text-gray-400 max-w-md mx-auto">Your trade account is currently pending admin approval. You'll receive an email once your account has been approved.</p>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
